/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_SummaryInputs */

const de__field_summary = /** @type {(inputs: _Field_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenfassung`)
};

/**

* @param {_Field_SummaryInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_summary = /** @type {((inputs?: _Field_SummaryInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_SummaryInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_summary(inputs)
});